export class Device {
  static isMobile() {
    if (typeof navigator === 'undefined') return false;
    const ua = navigator.userAgent;
    if (/android/i.test(ua)) return true;
    if (/iPad|iPhone|iPod/.test(ua)) return true;
    if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) return true;
    const ual = ua.toLowerCase();
    if (ual.indexOf('ipad') > -1) return true;
    if (ual.indexOf('macintosh') > -1 && 'ontouchend' in document) return true;
    return false;
  }
}
